import React from "react";

import { useHomeSectionsSettings } from "./hooks/useHomeSectionsSettings";

import HomeSectionsHeader from "./components/HomeSectionsHeader";
import HomeSectionsKpiCards from "./components/HomeSectionsKpiCards";
import HomeSectionsList from "./components/HomeSectionsList";

export default function SettingsHomeSections() {
  const dashboard = useHomeSectionsSettings();

  return (
    <div className="space-y-5">
      <HomeSectionsHeader
        loading={dashboard.loading}
        onRefresh={dashboard.refresh}
      />

      {/* <HomeSectionsKpiCards
        stats={dashboard.stats}
        loading={dashboard.loading}
      /> */}

      <HomeSectionsList
        sections={dashboard.sections}
        loading={dashboard.loading}
        savingId={dashboard.savingId}
        mediaInputs={dashboard.mediaInputs}
        onToggle={dashboard.handleToggle}
        onDragEnd={dashboard.handleDragEnd}
        onPositionChange={dashboard.handlePositionInput}
        onMediaInputChange={dashboard.handleMediaInputChange}
        onMediaSave={dashboard.handleMediaSave}
      />
    </div>
  );
}